exports = module.exports = require("/code/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".stamp-LightboxOverlay{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.95);opacity:0;-webkit-transition:opacity .1s linear;transition:opacity .1s linear;will-change:opacity;pointer-events:none;z-index:204}.stamp-LightboxOverlay[data-active=true]{opacity:1;pointer-events:auto;cursor:zoom-out}.stamp-LightboxOverlay.stamp-LightboxOverlay--poster,.stamp-LightboxOverlay.stamp-LightboxOverlay--cover{background-color:transparent}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** /code/~/css-loader?-minimize!/code/~/postcss-loader!/code/~/less-loader!./stamp/LightboxOverlay.less
 ** module id = 326
 ** module chunks = 1 2
 **/